/**
 * @file MainLayout.jsx
 * @author Rishikesh
 * @date 2024-09-09
 * @description Layout of the app which compains the header and drawer by including the main component of app.
 */
import { Box, Toolbar } from "@mui/material";
import React from "react";
import { Outlet } from "react-router-dom";
import Header from "../common/Header";
import SideBar from "../common/SideBar";
import { useSelector } from "react-redux";

const sidebarWidth = 240;

const MainLayout = () => {
  const role = useSelector((state) => state.auth.user?.role);
  return (
    <Box display="flex" flexDirection="column" height="100vh">
      <Header />
      <Box display="flex" flex={1} height="100%">
        <SideBar sidebarWidth={sidebarWidth} role={role} />
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            p: 2,
            overflow: "hidden",
            height: "100vh",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Toolbar />
          <Box
            sx={{
              flex: 1,
              backgroundColor: "white",
              borderRadius: "20px",
              overflowY: "auto",
              padding: 3,
            }}
          >
            <Outlet />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default MainLayout;
